import Main from './main';

export {
  Main
};
